module.exports = __webpack_public_path__ + "img/4.4.NH3-N.970d19a7.png";